import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { CONSENT_TYPES, resolveConsentType } from '../consent-types';

export interface ConsentFormsDialogData {
  pat: any;
}

@Component({
    selector: 'app-consent-forms',
    templateUrl: './consent-forms.component.html',
    styleUrls: ['./consent-forms.component.scss'],
    standalone: false
})
export class ConsentFormsComponent implements OnInit {
  consentTypes = CONSENT_TYPES;
  consents: any[] = [];
  loading = false;
  clinicPractitioners: any[] = [];
  practitionerObj: any = null;
  newConsentType: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConsentFormsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConsentFormsDialogData,
    public es: ExamsService,
    public ls: LoginService
  ) {}

  ngOnInit(): void {
    this.loadConsents();
    if (this.ls.userType !== 'doctor' && !this.ls.ishospital) {
      this.es.getAllPractitioners().subscribe((list: any) => {
        this.clinicPractitioners = list || [];
        if (this.clinicPractitioners.length === 1) {
          this.practitionerObj = this.clinicPractitioners[0];
        }
      });
    }
  }

  loadConsents() {
    if (!this.data.pat?.PID) return;
    this.loading = true;
    const today = new Date().toDateString();
    this.es.getUsgConsents(this.data.pat.PID.toString()).subscribe(
      (data: any[]) => {
        this.consents = (data || []).filter(c => new Date(c.CreationTime).toDateString() === today);
        this.loading = false;
      },
      () => { this.loading = false; }
    );
  }

  typeLabel(key: string): string {
    return resolveConsentType(key).label;
  }

  isSigned(c: any): boolean {
    return !!(c?.docSign && c?.patSign);
  }

  statusLabel(c: any): string {
    if (this.isSigned(c)) return 'נחתם';
    if (c?.printed) return 'הודפס';
    return 'לא נחתם';
  }

  openExisting(c: any) {
    this.es.consentType = c.ConsentType;
    this.es.examID = c.ExamID || null;
    this.dialogRef.close({ openForm: true, form: c });
  }

  printConsent(c: any) {
    window.open(`api/consent/print-usg/${c.AutoIndex}`);
  }

  canStartNew(): boolean {
    if (!this.newConsentType) return false;
    if (this.ls.userType !== 'doctor' && !this.ls.ishospital && this.clinicPractitioners.length > 1 && !this.practitionerObj) {
      return false;
    }
    return true;
  }

  startNew() {
    if (!this.canStartNew()) return;
    if (this.ls.userType !== 'doctor') {
      if (this.practitionerObj) {
        this.es.consentPractitioner = this.practitionerObj.Title + ' ' + this.practitionerObj.Name;
        this.es.consentDocUID = this.practitionerObj.UID;
      }
    } else {
      this.es.consentPractitioner = this.ls.username;
      this.es.consentDocUID = this.ls.UID;
    }
    this.es.examID = null;
    this.es.consentType = this.newConsentType;
    this.dialogRef.close({ openForm: true, form: null });
  }

  close() {
    this.dialogRef.close();
  }
}
